/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './AppRpc';
import * as Queries from './AppRpc.dfc.new';
import type { AdditionalContextArgs } from './AppRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseListSupportedAppsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.ListSupportedAppsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'listSupportedApps', References.ListSupportedAppsResponseType>
        : References.ListSupportedAppsResponseType)
    | undefined;
};

export function useListSupportedAppsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListSupportedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListSupportedAppsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_SUPPORTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listSupportedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListSupportedAppsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseListSupportedAppsQueryReturn<T>;
}

type UseListSupportedAppsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListSupportedAppsResponseType>,
    {},
    T extends true
      ? Record<'listSupportedApps', References.ListSupportedAppsResponseType>
      : References.ListSupportedAppsResponseType
  >;

export function useListSupportedAppsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListSupportedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListSupportedAppsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_SUPPORTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listSupportedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListSupportedAppsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListSupportedAppsLazyQueryReturn<T>;
}

type UseListSupportedAppsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListSupportedAppsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'listSupportedApps', References.ListSupportedAppsResponseType>
    : References.ListSupportedAppsResponseType;
};

export function useListSupportedAppsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListSupportedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListSupportedAppsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_SUPPORTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listSupportedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListSupportedAppsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListSupportedAppsSuspenseQueryReturn<T>;
}

type UseGetSupportedAppQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getSupportedApp', References.GetSupportedAppResponseType>
        : References.GetSupportedAppResponseType)
    | undefined;
};

export function useGetSupportedAppQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSupportedAppQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SUPPORTED_APP_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSupportedApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSupportedAppQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetSupportedAppQueryReturn<T>;
}

type UseGetSupportedAppLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType,
    T extends true
      ? Record<'getSupportedApp', References.GetSupportedAppResponseType>
      : References.GetSupportedAppResponseType
  >;

export function useGetSupportedAppLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSupportedAppLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SUPPORTED_APP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSupportedApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSupportedAppLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSupportedAppLazyQueryReturn<T>;
}

type UseGetSupportedAppSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getSupportedApp', References.GetSupportedAppResponseType>
    : References.GetSupportedAppResponseType;
};

export function useGetSupportedAppSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSupportedAppResponseType>,
    References.GetSupportedAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSupportedAppSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SUPPORTED_APP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSupportedApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSupportedAppSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSupportedAppSuspenseQueryReturn<T>;
}
